import { memo } from 'react'
import { Timer } from './components/timer'
import { useLiveRocketGame } from './use-live-rocket-game'

export const RocketGame = memo(() => {
  const { currentRocketGameLive } = useLiveRocketGame()

  return (
    <div
      className="flex items-center justify-center w-screen
    h-screen"
    >
      {currentRocketGameLive?.dateFinalInExploded && (
        <Timer
          key={currentRocketGameLive?.dateFinalInExploded}
          currentRocketGameLive={currentRocketGameLive}
        />
      )}
    </div>
  )
})
